import RandingStyle9 from "../../randing/RandingStyle9";

function Randing258({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/258/01.jpg`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/pink/ApplyBenefitButton.png`}
      adTarget="맘카페 이용자"
      eventDates={true}
      companyName="우가주치과병원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/uga.png`}
    />
  );
}

export default Randing258;
